export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_fragment_3.add65747.jpg";